// src/hooks/useInView.js
// Fires once when element enters the viewport. Used for scroll animations
// and impression tracking throughout the site.
import { useState, useEffect } from "react";

/**
 * @param {React.RefObject} ref
 * @param {string} margin  rootMargin passed to IntersectionObserver
 * @returns {boolean}      true once the element has entered the viewport
 */
export function useInView(ref, margin = "0px 0px -80px 0px") {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { rootMargin: margin }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return visible;
}
